// src/services/api/courierAssignmentRule.js
import { apiClient } from './base';

/**
 * Get all assignment rules for the business
 */
export const getAllAssignmentRules = async () => {
  try {
    const response = await apiClient.get('/courier-assignment-rules');
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get assignment rules for a specific business courier account
 * UPDATED: Now uses businessCourierId instead of courierCompanyId
 * @param {number} businessCourierId - The business courier account ID
 */
export const getRulesByBusinessCourier = async (businessCourierId) => {
  try {
    const response = await apiClient.get(`/courier-assignment-rules/account/${businessCourierId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get default assignment rule for a specific business courier account
 * UPDATED: Now uses businessCourierId instead of courierCompanyId
 * @param {number} businessCourierId - The business courier account ID
 */
export const getDefaultRuleByBusinessCourier = async (businessCourierId) => {
  try {
    const response = await apiClient.get(`/courier-assignment-rules/account/${businessCourierId}/default`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Create a new assignment rule
 * UPDATED: ruleData must now include businessCourierId instead of courierCompanyId
 * @param {Object} ruleData - The rule data (must include businessCourierId)
 */
export const createAssignmentRule = async (ruleData) => {
  try {
    const response = await apiClient.post('/courier-assignment-rules', ruleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update an existing assignment rule
 * @param {number} ruleId - The rule ID
 * @param {Object} ruleData - The updated rule data
 */
export const updateAssignmentRule = async (ruleId, ruleData) => {
  try {
    const response = await apiClient.put(`/courier-assignment-rules/${ruleId}`, ruleData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete an assignment rule
 * @param {number} ruleId - The rule ID
 */
export const deleteAssignmentRule = async (ruleId) => {
  try {
    const response = await apiClient.delete(`/courier-assignment-rules/${ruleId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Set a rule as default for its courier account
 * @param {number} ruleId - The rule ID
 */
export const setDefaultRule = async (ruleId) => {
  try {
    const response = await apiClient.post(`/courier-assignment-rules/${ruleId}/set-default`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Unset a rule as default
 * @param {number} ruleId - The rule ID
 */
export const unsetDefaultRule = async (ruleId) => {
  try {
    const response = await apiClient.post(`/courier-assignment-rules/${ruleId}/unset-default`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Toggle rule active status
 * @param {number} ruleId - The rule ID
 */
export const toggleAssignmentRule = async (ruleId) => {
  try {
    const response = await apiClient.post(`/courier-assignment-rules/${ruleId}/toggle`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Test assignment rules against sample orders
 * @param {Array} testOrders - Array of test order objects
 */
export const testAssignmentRules = async (testOrders) => {
  try {
    const response = await apiClient.post('/courier-assignment-rules/test', {
      testOrders
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};